import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import ReactQuill from 'react-quill';
import TagsInput from 'react-tagsinput';
import 'react-quill/dist/quill.snow.css';
import 'react-tagsinput/react-tagsinput.css';
import MainLayout from '../../components/layout/MainLayout';
import classes from './CreateBlog.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { createBlog, getAllBlogs } from '../../features/blog/blogSlice';
import Button from '../../components/UI/Button/Button';
import alertCreator from '../../utils/alertCreator';
function CreateBlog() {
  const dispatch = useDispatch();
  const { blogs } = useSelector((state) => state.blog);
  const { loading } = useSelector((state) => state.blog);
  const [tags, setTags] = useState([]);
  const [content, setContent] = useState([
    {
      btnText: '',
      btnLink: '',
      paragraph: '',
    },
  ]);
  const { register, handleSubmit, setValue } = useForm();

  useEffect(() => {
    dispatch(getAllBlogs());
  }, [dispatch]);

  const onSubmit = async ({
    title,
    description,
    relatedPosts,
    content,
    blogImg,
  }) => {
    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description);
    tags.forEach((tag) => formData.append('tags[]', tag));
    relatedPosts.forEach((relatedPost) =>
      formData.append('relatedPosts[]', relatedPost)
    );
    formData.append('blogImg', blogImg[0] || '');
    let filteredContent = content.filter(
      (con) => con.btnText || con.btnLink || con.paragraph
    );
    formData.append('content', JSON.stringify(filteredContent));

    const response = await dispatch(createBlog(formData));
    if (response.meta.requestStatus === 'fulfilled') {
      alertCreator({
        icon: 'success',
        title: 'Blog Created Successfully',
      });
    }
  };
  const addItem = () => {
    setContent([
      ...content,
      {
        btnText: '',
        btnLink: '',
        paragraph: '',
      },
    ]);
  };
  return (
    <MainLayout>
      <div className="container">
        <div className="row">
          <div className="col-md-8 col-12 mx-auto">
            <form
              onSubmit={handleSubmit(onSubmit)}
              className={`p-5 bg-light shadow m-5 rounded-lg ${classes.form}`}
            >
              <div className="mb-5">
                <input
                  className="form-control"
                  type="file"
                  {...register('blogImg')}
                />
              </div>
              <div className="mb-5">
                <input
                  className="form-control"
                  type="text"
                  {...register('title')}
                  placeholder="Title"
                />
              </div>
              <div className="mb-5">
                <textarea
                  {...register('description')}
                  className="form-control"
                  placeholder="Short paragraph for description"
                ></textarea>
              </div>

              {content.map((item, index) => (
                <React.Fragment key={index}>
                  <div className="mb-5">
                    <ReactQuill
                      theme="snow"
                      placeholder={`Paragraph ${index + 1}`}
                      onChange={(value) => {
                        setValue(`content[${index}].paragraph`, value);
                      }}
                    />
                    <textarea
                      className="d-none"
                      {...register(`content[${index}].paragraph`)}
                    ></textarea>
                  </div>

                  <div className="mb-5 d-flex gap-5">
                    <input
                      className="form-control"
                      type="text"
                      placeholder={`Button Text ${index + 1} `}
                      {...register(`content[${index}].btnText`)}
                    />
                    <input
                      className="form-control"
                      type="text"
                      placeholder={`Button Link ${index + 1}`}
                      {...register(`content[${index}].btnLink`)}
                    />
                  </div>
                </React.Fragment>
              ))}
              <div className="text-center mb-5">
                <button
                  className="btn btn-light"
                  onClick={addItem}
                  type="button"
                >
                  <img
                    src="https://res.cloudinary.com/lifecloud-qr/image/upload/v1675945312/plus_jusz7l.png"
                    alt="plus"
                  />
                </button>
              </div>

              <div className="mb-5">
                <select
                  {...register('relatedPosts')}
                  className="form-select"
                  multiple
                >
                  <option>Related Posts</option>

                  {blogs.map((blog) => (
                    <option key={blog._id} value={blog._id}>
                      {blog.title}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-5">
                <TagsInput value={tags} onChange={(tag) => setTags(tag)} />
              </div>
              <Button
                className="px-4 py-2"
                style={{ fontSize: '16px' }}
                loading={loading}
              >
                Submit
              </Button>
            </form>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
export default CreateBlog;
